import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class TeacherRankingConfigAPI extends BaseAPI {}

export default new TeacherRankingConfigAPI('v1/teacher-ranking-config', 'TeacherRankingConfig', getApiUrl(apis.TeacherAPI))
